import { queryOptions, useQuery } from '@tanstack/react-query';
import { customFetch } from '~/utils/customFetch';
import {
  analyticsUpdateRequestBoundsSchema,
  type AnalyticsUpdateRequestBounds,
} from '~/views/Staff/RequestAnalyticsUpdate/requestAnalyticsUpdateForm';

export const STAFF_ANALYTICS_UPDATE_REQUEST_QUERY_KEY = [
  'staff',
  'analytics-update-request',
] as const;

const fetchStaffAnalyticsUpdateRequestBounds = async (): Promise<AnalyticsUpdateRequestBounds> => {
  const { data, status } = await customFetch.get<unknown>(
    '/authenticated/staff/analytics/update-request',
    {
      headers: { 'Content-Type': 'application/json' },
      useNodeEndpoint: true,
      throwOnHTTPError: false,
    },
  );

  if (status >= 400) {
    const message =
      data &&
      typeof data === 'object' &&
      'message' in data &&
      typeof (data as { message: unknown }).message === 'string'
        ? (data as { message: string }).message
        : 'Failed to load analytics update bounds';
    throw new Error(message);
  }

  return analyticsUpdateRequestBoundsSchema.parse(data);
};

export const getStaffAnalyticsUpdateRequestBoundsQueryOptions = () =>
  queryOptions({
    queryKey: STAFF_ANALYTICS_UPDATE_REQUEST_QUERY_KEY,
    queryFn: fetchStaffAnalyticsUpdateRequestBounds,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

export const useStaffAnalyticsUpdateRequestBoundsQuery = () =>
  // eslint-disable-next-line @tanstack/query/prefer-query-object-syntax
  useQuery(getStaffAnalyticsUpdateRequestBoundsQueryOptions());
